import Box from '@mui/material/Box';
import { orderBy } from 'lodash';
import React from 'react';
import { PaperExpandable } from '../../../components/paper-expandable';
import { searchBy } from '../../../components/search-field';
import { FastractPendingData } from '../../../types';
import { ManageApprovalsItem } from './manage-approvals-item';

export function ManageApprovals(props: {
  AgtNo: string | undefined;
  data: FastractPendingData[];
  onSelect: (item: FastractPendingData) => void;
}) {
  // State
  const [searchString, setSearchString] = React.useState('');

  // Ordering
  const orderedItems = orderBy(props.data, 'CreatedDate', 'desc');
  // Searching
  const searchedItems = searchBy(orderedItems, searchString);

  return (
    <PaperExpandable
      open
      title="Fastract Approvals"
      description="These Agents are ready to be placed in your Hierarchy."
      count={props.data.length}
      searchString={searchString}
      onChangeSearch={(event) => setSearchString(event.target.value)}
    >
      {searchedItems.length > 0 ? (
        <Box component="ul" sx={{ p: 0, m: 0 }}>
          {searchedItems.map((item) => {
            return (
              <ManageApprovalsItem
                key={item.AgtNo}
                item={item}
                onClick={() => props.onSelect(item)}
              />
            );
          })}
        </Box>
      ) : (
        <Box
          sx={{
            p: 4,
            textAlign: 'center',
            fontFamily: 'Roboto Mono',
            color: '#9b9b9b',
          }}
        >
          No agents are waiting on approval
        </Box>
      )}
    </PaperExpandable>
  );
}
